// extracted by mini-css-extract-plugin
export default {"root":"slideOne_root__1dOR3"};